// extracted by mini-css-extract-plugin
module.exports = {"report":"reportes_report__sCfwZ","title":"reportes_title__PdppB","review":"reportes_review__3tPGB"};